import { useEffect, useRef, useState } from "react";
import "./ReaderPreview.css";

// Light animation timeline (ms). Tweak freely.
const FADE_MS = 500;     // duration of each fade on/off
const HOLD_ON_MS = 350;  // how long it stays lit at each peak
const HOLD_OFF_MS = 250; // how long it stays dark between pulses

// Sequence: fade on → off → on → off → snap on (hold).
// Each entry: [targetOpacity, transitionMs, holdAfterMs]
const ROPE_DROP_SEQUENCE = [
  [1, FADE_MS, HOLD_ON_MS],   // fade on
  [0, FADE_MS, HOLD_OFF_MS],  // fade off
  [1, FADE_MS, HOLD_ON_MS],   // fade on
  [0, FADE_MS, HOLD_OFF_MS],  // fade off
  [1, 0, 0],                  // SNAP on (0ms transition) and stay
];

const ReaderPreview = ({ animation }) => {
  const [lightOpacity, setLightOpacity] = useState(0);
  const [transitionMs, setTransitionMs] = useState(FADE_MS);
  const timersRef = useRef([]);

  const clearTimers = () => {
    timersRef.current.forEach(clearTimeout);
    timersRef.current = [];
  };

  // Cleanup on unmount
  useEffect(() => () => clearTimers(), []);

  // Run a sequence when `animation` changes to a known value.
  useEffect(() => {
    clearTimers();
    if (animation !== "ropedrop") {
      // reset to reader-only (no sequence defined yet for the others)
      setTransitionMs(0);
      setLightOpacity(0);
      return;
    }

    let elapsed = 0;
    ROPE_DROP_SEQUENCE.forEach(([target, transMs, holdMs]) => {
      const t = setTimeout(() => {
        setTransitionMs(transMs);
        setLightOpacity(target);
      }, elapsed);
      timersRef.current.push(t);
      elapsed += transMs + holdMs;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animation]);

  return (
    <div className="rp-container">
      <img className="rp-reader" src="/static/reader.png" alt="Reader" />
      <img
        className="rp-light"
        src="/static/light.png"
        alt=""
        style={{ opacity: lightOpacity, transition: `opacity ${transitionMs}ms ease` }}
      />
    </div>
  );
};

export default ReaderPreview;
